// 登录
import request from '@/utils/request'
export function login(data) {
    return request({
        url: '/front/user/auth/login',
        method: 'post',
        data
    })
}
// 注册
export function register(data) {
    return request({
        url: '/front/user/auth/register',
        method: 'post',
        data
    })
}
// 查询位置信息区域
export function queryCurrentLocation(data) {
    return request({
        url: '/front/area/queryCurrentLocation',
        method: 'post',
        data
    })
}

/**
 * 查询信息接口
 */
export function getAuditStatus() {
    return request({
        url: '/front/user/getLoginUserInfo',
        method: 'GET',
        data: {}
    })
}

/**
 * 获取验证码
 */
export function getCode(data) {
    return request({
        url: '/front/user/auth/getCode',
        method: 'post',
        data
    })
}